import {connect} from "react-redux";
import {RootState} from "../../reducers";
import {
  CancellationModal as Component,
  CancellationModalProps
} from "./CancellationModal.component";
import {getPartnerDetails} from "../../selector";
import {
  refreshReducersToInitial,
  updatePartnerDetailsDisplayCode,
  updatePartnerDetailsPartnerCode,
  updatePartnerDetailsRoute
} from "../../action";


const mapStateToProps = (state:RootState) => ({
  partnerDetails: getPartnerDetails(state)
} as Pick<CancellationModalProps, 'partnerDetails'>)

const mapDispatchToProps = ({
  refreshReducersToInitial,
  updatePartnerDetailsPartnerCode,
  updatePartnerDetailsDisplayCode,
  updatePartnerDetailsRoute
} as Pick<CancellationModalProps, 'refreshReducersToInitial'|'updatePartnerDetailsPartnerCode'|'updatePartnerDetailsDisplayCode' |'updatePartnerDetailsRoute'>)

export const CancellationModal = connect(mapStateToProps, mapDispatchToProps)(Component);
